var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-tabs",
    {
      on: { "tab-click": _vm.handleClick },
      model: {
        value: _vm.activeName,
        callback: function($$v) {
          _vm.activeName = $$v
        },
        expression: "activeName"
      }
    },
    [
      _c(
        "el-tab-pane",
        { attrs: { label: "资源动作", name: "rescAction" } },
        [
          _vm.activeName == "rescAction"
            ? _c("swb-com-role-resc-action", {
                attrs: {
                  readOnly: _vm.readOnly,
                  roleId: _vm.roleId,
                  roleName: _vm.roleName,
                  bizUnitLevel: _vm.comInfo.bizUnitLevel
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tab-pane",
        {
          attrs: {
            disabled: !_vm.comInfo.postOrgEnabled,
            label: "组织结构",
            name: "org"
          }
        },
        [
          _vm.activeName == "org"
            ? _c("swb-com-role-org", {
                attrs: {
                  readOnly: _vm.readOnly,
                  roleId: _vm.roleId,
                  roleName: _vm.roleName
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tab-pane",
        {
          attrs: {
            disabled: !_vm.comInfo.postGoodsCatEnabled,
            label: "商品分类",
            name: "goodsCat"
          }
        },
        [
          _vm.activeName == "goodsCat"
            ? _c("swb-com-role-goods-cat", {
                attrs: {
                  readOnly: _vm.readOnly,
                  roleId: _vm.roleId,
                  roleName: _vm.roleName
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tab-pane",
        {
          attrs: {
            disabled: !_vm.comInfo.postSubShopTagFilterEnabled,
            label: "机构标签",
            name: "shopTag"
          }
        },
        [
          _vm.activeName == "shopTag"
            ? _c("swb-com-role-shop-tag", {
                attrs: { readOnly: _vm.readOnly, roleId: _vm.roleId }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tab-pane",
        {
          attrs: {
            disabled: !_vm.comInfo.postDevcGrpEnabled,
            label: "设备分类分组",
            name: "devcGroup"
          }
        },
        [
          _vm.activeName == "devcGroup"
            ? _c("swb-com-role-devc-group", {
                attrs: { readOnly: _vm.readOnly, roleId: _vm.roleId }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-tab-pane",
        {
          attrs: {
            disabled: !_vm.comInfo.postMgmtAreaEnabled,
            label: "管理地区",
            name: "mgmtArea"
          }
        },
        [
          _vm.activeName == "mgmtArea"
            ? _c("swb-com-role-mgmt-area", { attrs: { roleId: _vm.roleId } })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9083a68e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9083a68e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/authx/ComRoleBusinessSet.vue
// module id = 3415
// module chunks = 0